<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title regular light-green">
            {{$parent.textPageTitle}}
          </div>
        </div>
        <img src="./../img/welcome2.png" class="img"/>
      </div>
      <div class="section text-section">
        <transition name="fade">
          <div class="wrapper" v-if="$parent.textPageTitle">
            <div class="content">
              <div class="desc" v-html="$parent.textPageContent"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'TextPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  mounted() {
    this.$parent.getTextPageContent(this.$route.params.id.replace(/\//g, '').replace(/ /g, '-'));
  },
  methods: {
    
  }
}
</script>